import { colors } from "./colors";
export var gradients = {
    red_vodafone: "linear-gradient(45deg, ".concat(colors.$820000, " 0%, ").concat(colors.$e60000, " 100%)"),
    skeleton_shadow: "linear-gradient(0.25turn, ".concat(colors.$eeeeee, ", ").concat(colors.$ffffff, ", ").concat(colors.$eeeeee, ")")
};
